<template>
	<div>
		<div class="w-full flex justify-between fixed navbar navbar-height z-10 pt-10">
			<div class="w-24">
				<div @click="$emit('openMenu')" v-if="showBackButton">
					<div class="py-4 w-12">
						<font-awesome-icon :icon="['fas', 'arrow-left']" class="w-4 h-4 text-white" size="lg" />
					</div>
				</div>
			</div>

			<div class="flex justify-center items-center ">
				<img class="w-64 p-3" src="../../../assets/logo.svg" alt="IMD-CONNECT.PRO Logo" />
			</div>
			<div class="w-24" />
		</div>
		<div class="navbar-height"></div>
	</div>
</template>

<script>
export default {
	name: 'AppsEmployeeSiteHeader',
	computed: {
		showBackButton() {
			return !['AppsEmployeeStart', 'AppsEmployeeLogin', 'AppsEmployeeMain'].includes(this.$route.name);
		},
	},
};
</script>

<style lang="sass" scoped>

.navbar-height
	height: calc(#{$navbar_height} + 40px)

.navbar
	background-color: #cdd2dd
</style>
